//#################### Path :: app/scripts/hereMap30.js//####################
var behavior,
bubble,
currentPositionMarker,
defaultLayers,
destIconSvgMarkup = '<svg width="18" height="18" ' +
'xmlns="http://www.w3.org/2000/svg">' +
'<circle cx="8" cy="8" r="8" ' +
'fill="#EC3636" stroke="white" stroke-width="1"  />' +
'</svg>',
destIcon = new H.map.Icon(destIconSvgMarkup, {anchor: {x: 8, y: 8}}),
entravesEnabled = false,
fromRefresh = sessionStorage.mapZoom || sessionStorage.mapCenter,
lastRoute,
linksToAvoid = [],
map,
maneuverFencesGroup = new H.map.Group(),
maneuverFencesGroupPinPoint = new H.map.Group(),
minZoom = 10,
mode = "truck",
navigation,
navigatorLocation,
normalBaseLayer,
workZonesProvider = new H.map.provider.LocalObjectProvider({min:12}),
workZonesGroup = new H.map.Group(),
workZonesLayer,
platform,
routePolyline,
scaleBar,
startDestMarkerGroup,
trafficEnabled = true,
trafficLayer,
truckRestrictionsEnabled = false,
truckRestrictionsLayer,
eveningRestrictionsLayer,
    eveningRestrictionsGroup  = new H.map.Group(),
eveningRestrictionsLayerHere,
eveningRestrictionsLayerHereYes,
transitRestrictionsLayer,
    transitRestrictionsGroup = new H.map.Group(),
localRestrictionsLayer,
truckWeight = 0,
truckHeight = 0,
hazmat = "",
ui,
startGeocodeVal = null,
startIconSvgMarkup = '<svg width="18" height="18" ' +
'xmlns="http://www.w3.org/2000/svg">' +
'<circle cx="8" cy="8" r="8" ' +
'fill="#008000" stroke="white" stroke-width="1"  />' +
'</svg>',
startIcon = new H.map.Icon(startIconSvgMarkup, {anchor: {x: 8, y: 8}}),
voiceGuidanceEnabled = false,
zoomControl,
appID = 'prTHesu7Ak5dAHaGEpr2',
appCode = 'sjt6tk7eCmhHhoRVrCTdqw';


function initHereMap30(mapName) {

    initPlatform();
    initMap(mapName);
    initLayers();
    if (!fromRefresh) {
        getNavigatorLocation(initGeolocation);
    }
    navigator.geolocation.watchPosition(onClientLocated, function (error) {
        console.log(error);
    }, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    });
    //Reprendre les anciennes valeurs dans le cas d'un rafraichissement de page
    restoreLastSession();
    setUpClickListener(map);

    /*$.ajax({
    url: "/data/avoidAreas.json",
    type: "GET",
    dataType:'json',
    async: false
}).done(function(data){
var dataI = 0;
$.each( data, function( key, val ) {
var rectPos = new H.geo.Rect(val[0], val[1], val[2], val[3]);

// Create a style object:
var customStyle = {
strokeColor: 'black',
fillColor: 'rgba(255, 255, 255, 0.1',
lineWidth: 1,
lineCap: 'square',
lineJoin: 'bevel'
};

var rect = new H.map.Rect(rectPos, { style: customStyle });
map.addObject(rect);
});
});*/
}

function restoreLastSession(){
    if (localStorage.truckWeight) {
        truckWeight = localStorage.truckWeight;
    }
    if (localStorage.truckHeight) {
        truckHeight = localStorage.truckHeight;
    }
    if (localStorage.hazmat) {
        hazmat = localStorage.hazmat;
    }
    else {
        hazmat = '';
    }

    if (sessionStorage.lastRoute) {
        lastRoute = JSON.parse(sessionStorage.lastRoute);
        displayRoute(lastRoute);
        $('#destSearchBox').typeahead('val', lastRoute.destinationText);
        $('#startSearchBox').typeahead('val', lastRoute.startText);
        $('#startSearchBox').data('coords', lastRoute.startCoords);
        $('#destSearchBox').data('coords', lastRoute.destinationCoords);
    }

    if (sessionStorage.mapCenter) {
        map.setCenter(JSON.parse(sessionStorage.mapCenter));
    }
    if (sessionStorage.mapZoom) {
        map.setZoom(sessionStorage.mapZoom);
    }
    fromRefresh = false;
}

function initGeolocation(position) {
    onClientLocated(position, true);
}

function initPlatform() {
    platform = new H.service.Platform({
        /*app_id: 'E603IBBdw0OEVuTByW38',
        app_code: 'RF6F3zch14e23gDO4SYQxg',*/
        app_id: appID,
        app_code: appCode,
        useCIT: true,
        useHTTPS: true
    });
    defaultLayers = platform.createDefaultLayers(512, 250);
}

function initLayers() {
    var mapTileService = platform.getMapTileService({'type': 'base'});
    normalBaseLayer = defaultLayers.normal.map;
    truckRestrictionsLayer = mapTileService.createTileLayer(
        'truckonlytile',
        'normal.day',
        512,
        'png8');
        truckRestrictionsLayer.opacity = 0.7;


    }

    function getRestrictions(){

        // console.log('area call');
        // var area = "";

        // $.ajax({
        //   dataType: "json",
        //   url: "/data/testarea100000.json",
        //   async: false
        // }).done(function( data ) {
        //     console.log('var area');
        //     var dataI = 0;
        //     $.each( data, function( key, val ) {
        //         if (dataI > 0) {
        //             area += '!';
        //         }
        //         area += val[0] + ',' + val[1] + ';' + val[3] + ',' + val[4];
        //         dataI ++;
        //     });
        //     map.addObject(rect);
        // }).fail(function( jqXHR, textStatus, errorThrown ) {
        //     console.log(errorThrown);
        // });


        /*
        $.ajax({
        url: "/data/2014Q3_CAN_Montreal_NoTrucks_test_Bruno.geojson",
        type: "GET"
    }).success(function(response){
    var reader = new H.data.geojson.Reader(null, {style:function(r){
    r.forEach(function(t){
    t.setStyle({strokeColor: '#8009c7', lineWidth: 5});
    // t.addEventListener('tap',function(z){console.log(z);});
});
}});
reader.parseData(response);
eveningRestrictionsLayerHere = reader.getLayer();
eveningRestrictionsLayerHere.setMin(2);
eveningRestrictionsLayerHere.opacity = 0.7;

}).done(function(){
map.addLayer(eveningRestrictionsLayerHere);
});
$.ajax({
url: "/data/2015Q3_CAN_Montreal_YesTrucks_bruno.geojson",
type: "GET"
}).success(function(response){
var reader = new H.data.geojson.Reader(null, {style:function(r){
r.forEach(function(t){
t.setStyle({strokeColor: '#f5dc27', lineWidth: 5});
// t.addEventListener('tap',function(z){console.log(z);});
});
}});
reader.parseData(response);
eveningRestrictionsLayerHereYes = reader.getLayer();
eveningRestrictionsLayerHereYes.setMin(2);
eveningRestrictionsLayerHereYes.opacity = 0.7;

}).done(function(){
map.addLayer(eveningRestrictionsLayerHereYes);
});
*/

$.ajax({
    url: "https://fniro.cartodb.com/api/v2/sql?format=GEOJson&q=SELECT%20*%20FROM%20fniro.camion_trc_polyline_1%20WHERE%20cam_class=2",
    type: "GET"
}).success(function(response){
    var reader = new H.data.geojson.Reader(null, {style:function(r){
        r.forEach(function(t){
            t.setStyle({strokeColor: '#00008B', lineWidth: 5});
            // t.addEventListener('tap',function(z){console.log(z);});
        });
    }});
    
    reader.addEventListener('statechange',function(evt){
        if (evt.state == H.data.AbstractReader.State.READY) {
            var parsedObjects = reader.getParsedObjects();
            parsedObjects.forEach(function (parsedObject) {
                createMapObjects(parsedObject, eveningRestrictionsGroup);
            });
        }
    });

    reader.parseData(response);
    eveningRestrictionsLayer = reader.getLayer();
    eveningRestrictionsLayer.setMin(2);
    eveningRestrictionsLayer.opacity = 0.7;

}).done(function(){
    $.ajax({
        url: "https://fniro.cartodb.com/api/v2/sql?format=GEOJson&q=SELECT%20*%20FROM%20fniro.camion_trc_polyline_1%20WHERE%20cam_class=1",
        type: "GET"
    }).success(function(response){
        var reader = new H.data.geojson.Reader(null, {style:function(r){
            r.forEach(function(t){
                t.setStyle({strokeColor: '#00BFFF', lineWidth: 5});
                // t.addEventListener('tap',function(z){console.log(z);});
            });
        }
    });
    reader.addEventListener('statechange',function(evt){
        if (evt.state == H.data.AbstractReader.State.READY) {
            var parsedObjects = reader.getParsedObjects();
            parsedObjects.forEach(function (parsedObject) {
                createMapObjects(parsedObject, transitRestrictionsGroup);
            });
        }
    });

    reader.parseData(response);
    transitRestrictionsLayer = reader.getLayer();
    transitRestrictionsLayer.setMin(2);
    transitRestrictionsLayer.opacity = 0.7;

}).done(function(){
    map.addLayer(eveningRestrictionsLayer);
    map.addLayer(transitRestrictionsLayer);
    if (entravesEnabled) {
        getWorkZones();
        toggleEntraves();
    }
});
});
}
// recursively look for parsed objects and add them to the group containing map objects
function createMapObjects(object, group) {
    var hasObjects = (object.getObjects != null && typeof object.getObjects() !== "undefined" && object.getObjects().length >= 1);
    if (hasObjects) {
        object.getObjects().forEach(function (innerObject) {
            createMapObjects(innerObject, group);
        });
    } else {
        group.addObject(object);
    }
}


function initMap(mapName) {
    
    
    var mapCenter = {lat: 45.501689, lng: -73.567256};
    var mapZoom = 13;
    $('#'+mapName).html('');
    trafficLayer = defaultLayers.normal.traffic;
    map = new H.Map(document.getElementById(mapName),
    trafficLayer, {
        center: mapCenter,
        zoom: mapZoom,
    });

    map.addObject(transitRestrictionsGroup);
    map.addObject(eveningRestrictionsGroup);

    initMapEventListeners();
    initMapControls();
    initMapBehavior();
    initMarkers();
}

function initMapEventListeners() {
    map.addEventListener('dragstart', function (evt) {
        if (navigation) {
            toggleNavigation();
        }
        closeBubbles();
    });
    map.addEventListener('mapviewchangeend', function (evt) {
        sessionStorage.mapZoom = map.getZoom();
        sessionStorage.mapCenter = JSON.stringify(map.getCenter());
    });

    map.addEventListener('longpress', function (evt) {
        navSearchClose();
        directionsClose();
        var x = evt.currentPointer.viewportX;
        var y = evt.currentPointer.viewportY;
        var geoPoint = map.screenToGeo(x,y);
        map.setCenter(geoPoint);

        reverseGeocode(geoPoint, function(geocodeResult){
            var mapLocation = geocodeResult.Response.View[0].Result[0].Location.DisplayPosition;
            var address = geocodeResult.Response.View[0].Result[0].Location.Address;

            var bubbleContent = document.createElement('div');


            var bubbleText = document.createElement("div");
            bubbleText.className = "map-address";
            var bubbleTextNode = document.createTextNode(address.Label);
            bubbleText.appendChild(bubbleTextNode);

            var buttonSetDest = document.createElement("button");
            buttonSetDest.className = "button button--invert";
            var buttonSetDestText = document.createTextNode("Destination");
            buttonSetDest.appendChild(buttonSetDestText);

            var buttonSetStart = document.createElement("button");
            buttonSetStart.className = "button button--invert";
            var buttonSetStartText = document.createTextNode("Point de départ");
            $(buttonSetStartText).attr('style',"font-family:roboto; font-size:12px;");
            buttonSetStart.appendChild(buttonSetStartText);

            bubbleContent.appendChild(bubbleText);
            bubbleContent.appendChild(buttonSetStart);
            bubbleContent.appendChild(buttonSetDest);

            buttonSetDest.addEventListener('click',function(evt){
                setPositionAsDestination(bubble.getPosition());
            });
            buttonSetStart.addEventListener('click',function(evt){
                setPositionAsStart(bubble.getPosition(), 1);
            });
            openBubble({lat: mapLocation.Latitude, lng: mapLocation.Longitude},bubbleContent);
        });

    });

    window.addEventListener('resize', function () {
        map.getViewPort().resize();
    });
    map.getViewModel().addEventListener('sync', function (evt) {
        if (evt.newValue.zoom <= minZoom) {
            map.setZoom(minZoom);
        }
    });
}

function initMapControls() {
    zoomControl = new H.ui.ZoomControl();
    scaleBar = new H.ui.ScaleBar();
    scaleBar.setAlignment(H.ui.LayoutAlignment.TOP_LEFT);
    ui = new H.ui.UI(map, {scalebar: scaleBar, zoom: zoomControl});
    //    ui = H.ui.UI.createDefault(map, platform.createDefaultLayers());
}

function initMapBehavior() {
    behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
}

function initMarkers() {

    if (!currentPositionMarker) {
        currentPositionMarker = new H.map.Marker(map.getCenter(), {data: {text: 'Votre Position'}});
        currentPositionMarker.addEventListener('tap', function (evt) {
            evt.stopPropagation();
            var bubbleContent = document.createElement('div');
            var bubbleText = document.createTextNode('Position actuelle');
            var bubbleButton = document.createElement('button');
            bubbleButton.className = "button radius tiny";
            var bubbleButtonText = document.createTextNode('Définir comme point de départ');

            bubbleButton.addEventListener('click', function(evt){
                evt.stopPropagation();
                setPositionAsStart(currentPositionMarker.getPosition());
            });

            bubbleContent.appendChild(bubbleText);
            bubbleButton.appendChild(bubbleButtonText);
            bubbleContent.appendChild(bubbleButton);

            openBubble(evt.target.getPosition(), bubbleContent);
        });
        currentPositionMarker.setVisibility(false);
    }
    map.addObject(currentPositionMarker);
}

function toggleTraffic() {
    if (trafficEnabled) {
        map.setBaseLayer(trafficLayer);
    } else {
        map.setBaseLayer(normalBaseLayer);
    }
}

function toggleTruckRestrictions() {
    if (truckRestrictionsEnabled) {
        map.addLayer(truckRestrictionsLayer);
    } else {
        map.removeLayer(truckRestrictionsLayer);
    }
}

function toggleEntraves() {
    if (map.getLayers().indexOf(workZonesLayer) != -1)
    map.getLayers().remove(workZonesLayer);
    else if (workZonesLayer)
    map.addLayer(workZonesLayer);
}

function toggleNavigation() {
    if (navigation) {
        $('.navigation').text('Commencer la navigation');
        voiceGuidanceEnabled = false;
    } else {
        centerOnCurrentLocation();
        voiceGuidanceEnabled = true;
        changeDirectionText(storeLastLegDirection);
        $('.navigation').text('Arrêter la navigation');

        'matchMedia' in window && window.matchMedia("(max-width: 1024px)").matches && directionsClose();

    }
    navigation = !navigation;
}

function centerOnCurrentLocation() {
    if (!navigatorLocation)
    {
        getNavigatorLocation(onClientLocated);
        return;
    }

    map.setCenter(navigatorLocation, true);
    map.setZoom(16, true);
}

function centerOnDestination() {
    map.setCenter({lat: lastRoute.waypoint[1].mappedPosition.latitude, lng: lastRoute.waypoint[1].mappedPosition.longitude}, true);
}

function getNavigatorLocation(cb) {
    if (geo_position_js.init()) {
        geo_position_js.getCurrentPosition(cb, onNavigatorLocationError, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
        });
    }
    else {
        onNavigatorLocationError();
    }
}

function onNavigatorLocationError() {
    directionsClose();
    toastr.error('Il a été impossible de déterminer votre position géographique. Les fonctionnalités d\'itinéraires ne sont pas affectées.','Impossible de déterminer votre position');
}

var lastLeg = -1;
var errorRoute = 0;
var changeDirection = false;
var lastLegDirection = 0;
var storeLastLegDirection = 0;
var legDoing = -1;
function onClientLocated(location, center) {
    var pos = {lat: location.coords.latitude, lng: location.coords.longitude};
    if (navigatorLocation && (navigatorLocation.lat !== location.coords.latitude || navigatorLocation.lng !== location.coords.longitude)) //If location changed
    {
        saveUserPosition(pos);
    } else if (!navigatorLocation){ //on init
        saveUserPosition(pos);
    }
    navigatorLocation = pos;

    reverseGeocode(navigatorLocation, function (geocodeResult) {
        var locationTextInt;
        if (geocodeResult.Response.View[0]) { //Si le geocodeur nous retourne un résultat correspondant a notre position
            //navigatorLocation = {lat: geocodeResult.Response.View[0].Result[0].Location.DisplayPosition.Latitude, lng: geocodeResult.Response.View[0].Result[0].Location.DisplayPosition.Longitude};
            var address = geocodeResult.Response.View[0].Result[0].Location.Address;
            if (address.HouseNumber && address.Street) {
                locationTextInt = address.HouseNumber + ' ' + address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Country + ',' + address.PostalCode;
            } else {
                locationTextInt = address.City + ', ' + address.State + ' ' + address.Country + ',' + address.PostalCode;
            }
        } else { //Sinon on affiche les coordonnées
            locationTextInt = 'Latitude: ' + navigatorLocation.lat + '; Longitude : ' + navigatorLocation.lng;
        }

        if (bubble && bubble.getPosition() == currentPositionMarker.getPosition()) {
            bubble.setPosition(navigatorLocation);
        }

        currentPositionMarker.setPosition(navigatorLocation);
        currentPositionMarker.setVisibility(true);

        if (navigation || center) {
            map.setCenter(navigatorLocation, true);
            if (map.getZoom() < 14) {
                map.setZoom(14, true);
            }


            legDoing = -1;
            maneuverFencesGroupPinPoint.forEach(function (fence, idFence) {
                if (fence.getBounds().containsPoint(navigatorLocation)) {
                    if (legDoing != fence.getData().leg) {
                        legDoing = fence.getData().leg;
                        changeDirection = true;
                        lastLegDirection = legDoing;
                        storeLastLegDirection = lastLegDirection;

                        if (navigation && legDoing == lastRoute.leg[0].maneuver.length - 1) {
                            toggleNavigation();
                        }
                    }
                }
            });


            if (navigation) {

                /*
                * Je suis ici : navigatorLocation
                * */
                /*
                coord = new H.geo.Point(your_Latitude, your_Longitude);

                var pixelcoord  = map.geoToScreen(navigatorLocation);
                var objects = map.getObjectsAt(pixelcoord.x, pixelcoord.y);
                console.log(objects);
*/
                /**
                TODO: À corriger avant de réactiver, le getObjectsAt retourne toujours au moins 1 car mon propre icone de positionnement est calculé comme un object
                **/
                /*
                var pixelcoord  = map.geoToScreen(navigatorLocation);
                var objects = map.getObjectsAt(pixelcoord.x, pixelcoord.y);
                $(document).trigger('restricted_area', [!! objects.length] );
                */





                    maneuverFencesGroup.forEach(function (fence) {
                    if (fence.getBounds().containsPoint(navigatorLocation)) {
                        if (lastLeg != fence.getData().leg) {
                            lastLeg = fence.getData().leg;
                            if (voiceGuidanceEnabled) {
                                responsiveVoice.speak(fence.getData().tts, 'French Female');
                            }
                            $('.directionDetail#' + fence.getData().maneuver.id).attr('style', 'background-color:yellowgreen');
                            maneuverFencesGroup.removeObject(fence);
                            if (lastLeg < lastRoute.leg[0].maneuver.length - 1) {
                                addGeofences(lastRoute.leg[0].maneuver, lastLeg);
                            }
                        }
                    }
                });

                if (legDoing === -1 && changeDirection && lastLegDirection !== -1) {
                    changeDirectionText(lastLegDirection);
                    changeDirection = false;
                    lastLegDirection = -1;
                    // maneuverFencesGroupPinPoint.removeObject(fence);
                }

                if (routePolyline) {
                    var rectPos = new H.geo.Rect(navigatorLocation.lat + 0.00033, navigatorLocation.lng - 0.0005, navigatorLocation.lat - 0.00033, navigatorLocation.lng + 0.0005);
                    var clipRoute = routePolyline.clip(rectPos);

                    if (clipRoute.length === 0 && lastRoute) {
                        errorRoute++;
                        if (errorRoute >= 5) {
                            var startCoords = navigatorLocation.lat + ',' + navigatorLocation.lng;
                            var destCoords = lastRoute.waypoint[1].originalPosition.latitude + ',' + lastRoute.waypoint[1].originalPosition.longitude;
                            calculateRouteFromAtoB(startCoords, destCoords);
                        }
                    }
                    else {
                        // Create a style object:
                        // var customStyle = {
                        //   strokeColor: 'black',
                        //   fillColor: 'rgba(255, 255, 255, 0.5',
                        //   lineWidth: 1,
                        //   lineCap: 'square',
                        //   lineJoin: 'bevel'
                        // };

                        // var rect = new H.map.Rect(rectPos, { style: customStyle });
                        // map.addObject(rect);
                        errorRoute = 0;
                    }
                }
            }
        }

        map.locationText = locationTextInt;
        currentPositionMarker.getData().text = map.locationText;
    });
}

function changeDirectionText(lastLegDirection) {
    var maneuverLeg = lastRoute.leg[0].maneuver[lastLegDirection + 1];
    var arrowValue = maneuverLeg.Direction;
    if (lastLegDirection === 0) { //depart
        arrowValue = 'depart';
    }
    switch (maneuverLeg.Direction) {
        case 'forward':

        break;
        case 'right':
        arrowValue = 'rightTurn';
        break;
        case 'left':
        arrowValue = 'leftTurn';
        break;
        case 'lightRight':
        arrowValue = 'slightRightTurn';
        break;
        case 'lightLeft':
        arrowValue = 'slightLeftTurn';
        break;
    }

    var maneuverInstructionsLeg = maneuverLeg.instruction.split('. Parcourez');
    // Get the next maneuver.
    var instruction = maneuverInstructionsLeg[0];
    var distance = '';
    if (maneuverInstructionsLeg[1]) {
        distance = maneuverInstructionsLeg[1];
    }
    var nextDirections = '<span class="arrow ' + arrowValue + '"></span>' + instruction ;
    $('#currentLocationText').parent().find('.fa-flag-checkered').remove();

    setFooterInfoText();

    if (lastLegDirection + 1 === lastRoute.leg[0].maneuver.length - 1) { //arrivee
        arrowValue = 'arrive';
        nextDirections = lastRoute.destinationText;
        $('#currentLocationText').parent().prepend('<i class="fa fa-flag-checkered"></i>');
    }

    $('#currentLocationText').html(nextDirections);

}

function calculateRemainingTimeAndDistance(lastLegDirection){
    var timeAndDistance = {'time' : 0, 'distance' : 0};

    for(var i = lastLegDirection; i < lastRoute.leg[0].maneuver.length; i++){
        timeAndDistance.time += lastRoute.leg[0].maneuver[i].travelTime;
        timeAndDistance.distance += lastRoute.leg[0].maneuver[i].length;
    }

    return timeAndDistance;
}

function distanceToPoyline(point1, point2, position) {
    return Math.abs(((point2.lng - point1.lng) * position.lng) - ((point2.lat - point1.lat) * position.lat) + (point2.lat * point1.lng) - (point2.lng * point1.lat)) / Math.sqrt(Math.pow(point2.lng - point1.lng, 2) + Math.pow(point2.lat - point1.lat, 2));
}

function startRouting() {
    var startCoords = $('#startSearchBox').data('coords');
    var destCoords = $('#destSearchBox').data('coords');
    if (!startCoords || startCoords === "") {
        return;
    }
    if (!destCoords || destCoords === "") {
        return;
    }

    lastLeg = -1;
    calculateRouteFromAtoB(startCoords, destCoords);
}

function uniq_fast(a) {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for(var i = 0; i < len; i++) {
        var item = a[i];
        if(seen[item] !== 1) {
            seen[item] = 1;
            out[j++] = item;
        }
    }
    return out;
}

function calculateRouteFromAtoB(start, dest) {
    if (!start || start === "" || start == "0,0" || !dest || dest === "" || dest == "0,0") {
        return;
    }

    var hazmatArray=hazmat.split(",");


    var area = "";
    $.ajax({
        url: "/data/avoidAreas.json",
        type: "GET",
        dataType:'json',
        async: false
    }).done(function(data){
        var dataI = 0;
        $.each( data, function( key, val ) {
            if (dataI > 0) {
                area += '!';
            }
            area += val[0] + ',' + val[1] + ';' + val[2] + ',' + val[3];
            dataI ++;
        });
    });

    // console.log('route');
    // console.log(linksToAvoid.length);
    // linksToAvoid = uniq_fast(linksToAvoid);
    // console.log(linksToAvoid.length);
    // linksToAvoid = linksToAvoid.slice(0,200);
    // console.log(linksToAvoid.length);
    var router = platform.getRoutingService(),
    routeRequestParams = {
        mode: 'fastest;' + mode + ';traffic:enabled',
        representation: 'navigation',
        waypoint0: start,
        waypoint1: dest,
        instructionformat: 'text',
        legAttributes: ['tt'],
        alternatives: 1,
        language: 'fr-ca',
        shippedhazardousgoods: hazmatArray,
        limitedWeight: truckWeight,
        height: truckHeight,
        // avoidlinks: linksToAvoid.join(),
        departure: 'now',
        //                    width: 4,
        //                    length: 20,
        //                    limitedWeight: 20,
        //                    permittedGrossWeight: 30,
        //                    weightPerAxle: 10,
        // avoidAreas: area,
    };
    router.calculateRoute(
        routeRequestParams,
        onCalculateRouteSuccess,
        onError
    );
}

function onCalculateRouteSuccess(result) {

    // console.log(result);
    if(! result.hasOwnProperty('response') || ! result.response.hasOwnProperty('route')){
        return onError();
    }
    var route = result.response.route[0];
    route.destinationText = $('#destSearchBox').typeahead('val');
    route.destinationCoords = $('#destSearchBox').data('coords');
    route.startText = $('#startSearchBox').typeahead('val');
    route.startCoords = $('#startSearchBox').data('coords');
    lastRoute = route;
    sessionStorage.lastRoute = JSON.stringify(lastRoute);
    navSearchClose();
    displayRoute(route);
    saveUserRoute(route);
}

function onError(error) {
    toastr.error('Impossible de déterminer la route demandée.', 'Une erreur est survenue');
}

function recalculateLastRoute() {
    if (lastRoute) {
        var startCoords = lastRoute.waypoint[0].originalPosition.latitude + ',' + lastRoute.waypoint[0].originalPosition.longitude;
        var destCoords = lastRoute.waypoint[1].originalPosition.latitude + ',' + lastRoute.waypoint[1].originalPosition.longitude;
        calculateRouteFromAtoB(startCoords, destCoords);
    }
}

function geocode(searchTerm, cb) {
    var geocoder = platform.getGeocodingService();
    var geocodingParameters;
    geocodingParameters = {
        searchText: searchTerm
    };
    geocoder.geocode(geocodingParameters, function (result) {
        cb(result);
    }, function (error) {
        // console.log(error);
    });
}

function reverseGeocode(position, cb) {
    if (!cb || typeof cb !== "function") {
        console.error('callback parameter not defined or not a function');
        return;
    }
    var geocodingService = platform.getGeocodingService();
    geocodingService.reverseGeocode({prox: position.lat + ',' + position.lng, mode: 'retrieveAddresses'},
    function (result) {
        cb(result);
    }, onError);
}

function getLinksToAvoid(collection) {
    linksToAvoid = [];
    var enterpriseRoutingService = platform.getRoutingService();


    for (i = 0; i < collection.length; i++) {
        if (collection[i].dontAdd != 1) {
            for (var j = 0; j < collection[i].coordinates.length; j++) {

                var placemarker = collection[i];

                $.ajax({
                    url: "https://route.cit.api.here.com/routing/7.2/getlinkinfo.json?waypoint=geo!"+placemarker.coordinates[j].latitude+","+placemarker.coordinates[j].longitude+"&language=en-us&mode=car&app_id="+appID+"&app_code="+appCode+"&verbosemode=0",
                    type: "GET",
                    dataType: "json",
                    async: true
                })
                .success(onSuccesGetLinkInfoJSON)
                .error(onErrorGetLinkInfoJSON);
            }
        }
    }
}

function onSuccesGetLinkInfoJSON(result) {
    var linkId = result.response.link[0].linkId;
    linksToAvoid.push(linkId);
}

function onErrorGetLinkInfoJSON(jqXHR, textStatus, errorThrown) {
    console.log(errorThrown);
}

function onErrorGetLinkInfo(error) {
    console.log(error);
}

function displayRoute(route) {
    addRouteShapeToMap(route);
    addStartDestMarkers(route);
    addDirections(route);
    setHeaderText(route.destinationText);
    setFooterInfoText();
}

/**
* Boilerplate map initialization code starts below:
*/

/**
* Opens/Closes a infobubble
* @param  {H.geo.Point} position     The location on the map.
* @param  {String} text              The contents of the infobubble.
*/
function openBubble(position, text) {
    if (!bubble) {
        bubble = new H.ui.InfoBubble(
            position,
            // The FO property holds the province name.
            {content: text});
            ui.addBubble(bubble);
        } else {
            bubble.setPosition(position);
            bubble.setContent(text);
            bubble.open();
        }
    }

    function closeBubbles() {
        if (ui.getBubbles() && ui.getBubbles().length > 0) {
            ui.getBubbles().forEach(function (item) {
                item.close();
            });
        }
    }


    /**
    * Creates a H.map.Polyline from the shape of the route and adds it to the map.
    * @param {Object} route A route as received from the H.service.RoutingService
    */
    function addRouteShapeToMap(route) {
        if (routePolyline) {
            map.removeObject(routePolyline);
        }
        var strip = new H.geo.Strip(),
        routeShape = route.shape;
        routeShape.forEach(function (point) {
            var parts = point.split(',');
            strip.pushLatLngAlt(parts[0], parts[1]);
        });
        routePolyline = new H.map.Polyline(strip, {
            style: {
                lineWidth: 10,
                strokeColor: 'rgba(245, 13, 13, 0.8)'
            }
        });
        routePolyline.setArrows({fillColor:'#fff'});

        // Add the polyline to the map
        map.addObject(routePolyline);
        // And zoom to its bounding rectangle
        if (!fromRefresh) {
            map.setViewBounds(routePolyline.getBounds(), true);
        }
    }
    


    /**
    * Creates a series of H.map.Marker points from the route and adds them to the map.
    * @param {Object} route  A route as received from the H.service.RoutingService
    */
    function addManueversToMap(route) {
        var svgMarkup = '<svg width="18" height="18" ' +
        'xmlns="http://www.w3.org/2000/svg">' +
        '<circle cx="8" cy="8" r="8" ' +
        'fill="#1b468d" stroke="white" stroke-width="1"  />' +
        '</svg>',
        dotIcon = new H.map.Icon(svgMarkup, {anchor: {x: 8, y: 8}}),
        group = new H.map.Group(),
        i,
        j;
        // Add a marker for each maneuver
        for (i = 0; i < route.leg.length; i += 1) {
            for (j = 0; j < route.leg[i].maneuver.length; j += 1) {
                // Get the next maneuver.
                maneuver = route.leg[i].maneuver[j];
                // Add a marker to the maneuvers group
                var marker = new H.map.Marker({
                    lat: maneuver.position.latitude,
                    lng: maneuver.position.longitude},
                    {icon: dotIcon});
                    marker.instruction = maneuver.instruction;
                    group.addObject(marker);
                }
            }

            group.addEventListener('tap', function (evt) {
                map.setCenter(evt.target.getPosition());
                openBubble(
                    evt.target.getPosition(), evt.target.instruction);
                }, false);
                // Add the maneuvers group to the map
                map.addObject(group);
            }

            function addStartDestMarkers(route) {
                if (startDestMarkerGroup) {
                    map.removeObject(startDestMarkerGroup);
                }
                startDestMarkerGroup = new H.map.Group();
                // Add a marker for each maneuver
                var icons = [startIcon, destIcon];
                for (j = 0; j < route.waypoint.length; j++) {
                    // Get the next maneuver.
                    markerPosition = route.waypoint[j].mappedPosition;
                    // Add a marker to the maneuvers group
                    var marker = new H.map.Marker({
                        lat: markerPosition.latitude,
                        lng: markerPosition.longitude});
                        marker.setIcon(icons[j]);
                        startDestMarkerGroup.addObject(marker);
                    }

                    // Add the maneuvers group to the map
                    map.addObject(startDestMarkerGroup);
                }

                function directionDetails(directionId) {
                    //directionId = 'M' + directionId;
                    var direction = getDirectionById('M' + directionId);
                    if(! direction) return;
                    //var nextDirection = getDirectionById(direction.nextManeuver);

                    var directionPos = {lat: direction.position.latitude, lng: direction.position.longitude};
                    map.setCenter(directionPos, true);
                    map.setZoom(14, true);
                    openBubble(directionPos, direction.instruction);


                    /*
                    lastRoute.leg[0].maneuver.forEach(function (direction) {
                        if (direction.id === directionId) {
                            lastRoute.leg[0].maneuver.forEach(function (nextDirection) {
                            //¨ca sert à quoi de trouver le next, on fait rien avec?
                                if (direction.nextmaneuver === nextDirection.id) {
                                    var directionPos = {lat: direction.position.latitude, lng: direction.position.longitude};
                                    map.setCenter(directionPos, true);
                                    map.setZoom(14, true);
                                    openBubble(directionPos, direction.instruction);
                                }
                            });
                        }
                    });*/
                }

                function getDirectionById(directionId) {
                    lastRoute.leg[0].maneuver.forEach(function (item) {
                        if (item.id === directionId) {
                            return item;
                        }
                    });
                    return null;
                }

                function addDirections(route) {
                    maneuverFencesGroup = new H.map.Group();
                    maneuverFencesGroupPinPoint = new H.map.Group();
                    $('[data-actions="actionsRoad"]').show();
                    var directions = $('.directions ul');
                    directions.html('');
                    directions.append('<li>' +
                    '<span></span>' +
                    '<button class="navigation button round expand" onclick="toggleNavigation()">Commencer la navigation</button><hr>' +
                    '</li>');
                    // Add a marker for each maneuver
                    for (j = 0; j < route.leg[0].maneuver.length; j += 1) {
                        var arrowValue;
                        if (j === 0) { //depart
                            arrowValue = 'depart';
                        } else if (j === route.leg[0].maneuver.length - 1) { //arrivee
                            arrowValue = 'arrive';
                        }
                        switch (route.leg[0].maneuver[j].direction) {
                            case 'forward':

                            break;
                            case 'right':
                            arrowValue = 'rightTurn';
                            break;
                            case 'left':
                            arrowValue = 'leftTurn';
                            break;
                            case 'lightRight':
                            arrowValue = 'slightRightTurn';
                            break;
                            case 'lightLeft':
                            arrowValue = 'slightLeftTurn';
                            break;
                        }

                        maneuver = route.leg[0].maneuver[j];
                        maneuverInstructions = route.leg[0].maneuver[j].instruction.split('. Parcourez');
                        // Get the next maneuver.
                        var instruction = maneuverInstructions[0];
                        var distance = '';
                        if (maneuverInstructions[1]) {
                            distance = maneuverInstructions[1];
                        }
                        directions.append('<li>' +
                        '<span class="arrow ' + arrowValue + '"></span>' +
                        '<p  class="directionDetail" id="' + maneuver.id + '" onclick="directionDetails(' + maneuver.id.split('M')[1] + ')">' + instruction + '<span>' + distance + '</span></p>' +
                        '</li>');
                    }

                    addGeofences(route.leg[0].maneuver, 0);
                    addGeofencesPinPoint(route.leg[0].maneuver);
                    // map.addObject(maneuverFencesGroupPinPoint);
                    if (!fromRefresh) {
                        directionsOpen();
                    }
                }

                function addGeofencesPinPoint(maneuver) {
                    for (var i = 0; i < maneuver.length; i++) {
                        var pos1 = new H.geo.Point(maneuver[i].position.latitude, maneuver[i].position.longitude);



                        maneuverFencesGroupPinPoint.addObject(new H.map.Circle(pos1, 15,
                            {
                                style: {
                                    strokeColor: 'rgba(55, 85, 170, 0.6)', // Color of the perimeter
                                    lineWidth: 2,
                                    fillColor: 'rgba(255, 0, 0, 0.7)'  // Color of the circle
                                },
                                data: {maneuver: maneuver[i], leg: i}

                            }));
                        }
                    }

                    function addGeofences(maneuver, position) {
                        var distanceMax = 200;
                        for (var i = position; i <= position + 1; i++) {
                            var pos1 = new H.geo.Point(maneuver[i].position.latitude, maneuver[i].position.longitude);

                            var distanceToNext = distanceMax;
                            if (i < maneuver.length - 1) {
                                var pos2 = new H.geo.Point(maneuver[i + 1].position.latitude, maneuver[i + 1].position.longitude);
                                distanceToNext = pos2.distance(pos1);
                            }

                            var distanceToPrevious = distanceMax;
                            if (i > 0) {
                                var pos0 = new H.geo.Point(maneuver[i - 1].position.latitude, maneuver[i - 1].position.longitude);
                                distanceToPrevious = pos1.distance(pos0);
                            }

                            var ttsTexte = maneuver[i].instruction;
                            if (i < maneuver.length - 1) {
                                ttsTexte = ttsTexte + "Puis, " + maneuver[i + 1].instruction.split('. Parcourez')[0];
                            }

                            var groupoption = {
                                style: {
                                    strokeColor: 'rgba(55, 85, 170, 0.6)', // Color of the perimeter
                                    lineWidth: 2,
                                    fillColor: 'rgba(0, 128, 0, 0.7)'  // Color of the circle
                                },
                                data: {tts: ttsTexte, maneuver: maneuver[i], leg: i}
                            };

                            if (distanceToNext >= distanceMax && distanceToPrevious >= distanceMax) {
                                maneuverFencesGroup.addObject(new H.map.Circle(pos1, distanceMax, groupoption));
                            } else {

                                var closestPosition = distanceToNext;
                                if (distanceToNext > distanceToPrevious) {
                                    closestPosition = distanceToPrevious;
                                }

                                maneuverFencesGroup.addObject(new H.map.Circle(pos1, closestPosition / 2, groupoption));
                            }
                        }
                    }


                    function saveUserPosition(position) {
                        $.ajax({
                            url: "user.php",
                            data: {"url-action": "saveUserPosition", "position": JSON.stringify(position)},
                            type: "POST"
                        });
                    }
                    function saveUserRoute(direction) {
                        $.ajax({
                            url: "user.php",
                            data: {"url-action": "saveUserRoute", "direction": JSON.stringify(direction)},
                            type: "POST"
                        });
                    }

                    function setPositionAsStart(position, geo) {
                        if (geo == 1) {
                            reverseGeocode(position, function(geocodeResult){
                                $('#startSearchBox').typeahead('val',geocodeResult.Response.View[0].Result[0].Location.Address.Label);
                                $('#startSearchBox').data('coords', geocodeResult.Response.View[0].Result[0].Location.DisplayPosition.Latitude + ',' + geocodeResult.Response.View[0].Result[0].Location.DisplayPosition.Longitude);
                                navSearchOpen();
                                closeBubbles();
                            });
                        }
                        else {
                            $('#startSearchBox').typeahead('val',map.locationText);
                            $('#startSearchBox').data('coords', position.lat + ',' + position.lng);
                            navSearchOpen();
                            closeBubbles();
                        }
                    }

                    function setPositionAsDestination(position) {
                        reverseGeocode(position, function(geocodeResult){
                            $('#destSearchBox').typeahead('val',geocodeResult.Response.View[0].Result[0].Location.Address.Label);
                            $('#destSearchBox').data('coords', geocodeResult.Response.View[0].Result[0].Location.DisplayPosition.Latitude + ',' + geocodeResult.Response.View[0].Result[0].Location.DisplayPosition.Longitude);
                            navSearchOpen();
                            closeBubbles();
                        });
                    }

                    function setHeaderText(text) {
                        $('.header-infos.left').show();
                        $('#currentLocationText').parent().find('.fa-flag-checkered').remove();
                        $('#currentLocationText').parent().prepend('<i class="fa fa-flag-checkered"></i>');
                        $('#currentLocationText').text(text);
                    }


                    function setFooterInfoText(){

                        $('.informations__road').text('via ' + lastRoute.label.join(', '));
                        var timeAndDistance = calculateRemainingTimeAndDistance(Math.max(lastLeg, 0));
                        var duration = moment.duration(timeAndDistance.time*1000);

                        $('.informations__time').text((duration._data.hours > 0 ? duration._data.hours + ' heures et ' : '') + duration._data.minutes + ' minutes, ');
                        $('.informations__km').text(Math.round(timeAndDistance.distance / 1000 , 2) + ' km');

                    }

                    function setUpClickListener(map) {
                        // Attach an event listener to map display
                        // obtain the coordinates and display in an alert box.
                        map.addEventListener('tap', function (evt) {
                            var coord = map.screenToGeo(evt.currentPointer.viewportX,
                                evt.currentPointer.viewportY);
                                console.log(" " + coord.lat + "," + coord.lng);
                            });
                        }



